import { logEvent } from 'firebase/analytics';
import { analytics } from '../firebase';

// Custom analytics functions for your Kid's Vibes store
export const trackEvent = (eventName, parameters = {}) => {
  try {
    logEvent(analytics, eventName, parameters);
    console.log(`📊 Analytics: ${eventName}`, parameters);
  } catch (error) {
    console.error('Analytics error:', error);
  }
};

// Specific tracking functions for your store
export const trackProductView = (productId, productName) => {
  trackEvent('view_item', {
    item_id: productId,
    item_name: productName,
    item_category: 'accessories'
  });
};

export const trackAddToCart = (productId, productName, price) => {
  trackEvent('add_to_cart', {
    currency: 'USD',
    value: parseFloat(price),
    item_id: productId,
    item_name: productName
  });
};

export const trackPurchase = (transactionId, value, items) => {
  trackEvent('purchase', {
    transaction_id: transactionId,
    value: value,
    currency: 'USD',
    items: items
  });
};

export const trackSearch = (searchTerm) => {
  trackEvent('search', {
    search_term: searchTerm
  });
};

export const trackPageView = (pageName, pageTitle) => {
  trackEvent('page_view', {
    page_title: pageTitle,
    page_location: window.location.href,
    page_name: pageName
  });
};

export const trackStoreVisit = () => {
  trackEvent('store_visit_interest', {
    source: 'location_page'
  });
};

export const trackAdminAction = (action, details = {}) => {
  trackEvent('admin_action', {
    action: action,
    ...details
  });
};
